import React, { ReactElement } from 'react';

import classes from './EmptyWarning.module.css';

interface EmptyWarningProps {
  message: React.ReactNode;
}

function EmptyWarning({ message }: EmptyWarningProps): ReactElement {
  return <h2 className={classes.warning}>{message}</h2>;
}

export default EmptyWarning;
